import { MeasureText } from "./MeasureText";
import { FindCharBreak } from "./FindCharBreak";

export function FindBreak(theContent, availableSpace, fontString, breakCharRegEx) {
  if (theContent.length == 0) return "";

  var priorString = FindCharBreak(theContent, availableSpace, fontString, breakCharRegEx);
  if (priorString.length > 0) return priorString;

  var subStr = "";
  var i = 0;
  var n = theContent.length;
  var done = false;

  while (!done) {
    priorString = subStr;
    subStr = subStr.concat(theContent[i++]);
    var m = MeasureText(subStr, fontString);
    if (m > availableSpace) {
      if (subStr.length == 1) priorString = subStr;
      done = true;
    } else if (i == n) {
      priorString = theContent;
      done = true;
    }
  }

  return priorString;
}
